// features
import PC from '../permission/role-permission';
// helpers
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

export const HEADER_HEIGHT = 48;
export const ELEMENT_HEIGHT = 28;
export const LAYOUT_HEIGHT_TRANSITION = 'height 300ms ease';
export const CENTRALIZED_DISPATCH_UI_SETTINGS = 'centralizedDispatchUISettings';
export const CENTRALIZED_DISPATCH_FILTER_SETTINGS = 'centralizedDispatchFilterSettings';
export const ADDITIONAL_FILTERS_AND_SORT = 'additionalFiltersAndSort';

export const CENTRALIZED_DISPATCH_PERMISSIONS = [
  [PC.TEL_READ, PC.TEL_WRITE],
  [PC.AVAILABLE_DRIVER_LIST_READ, PC.AVAILABLE_DRIVER_LIST_WRITE],
];

export const defaultAdditionalFiltersAndSort = {
  sort: [],
  filters: [],
};

export const tripFilterFormFieldNames = [
  GC.FIELD_STATUS,
  GC.FIELD_EVENT_COUNT,
  GC.FIELD_ORIGIN_ZONE,
  GC.FIELD_BRANCH_DOT_GUID,
  GC.FIELD_DESTINATION_ZONE,
  GC.FIELD_BRANCH_DOT_BRANCH_NAME,
  GC.GRC.RATE_MODE_DROPDOWN_OPTION_GUID,
];

export const defaultModeUISettings = {
  layout: 'horizontal',
  activeTab: 'drivers',
  verticalHeight: '50%',
  horizontalWidth: '50%',
};

export const layoutOptions = [
  { name: 'Horizontal', value: 'horizontal', width: 70 },
  { name: 'Vertical', value: 'vertical', width: 55 },
  { name: 'Tabs', value: 'tabs', width: 35 },
];

export const searchOptions = [
  { name: G.getWindowLocale('titles:drivers', 'Drivers'), value: 'drivers', width: 55 },
  { name: G.getWindowLocale('titles:tels', 'Trips'), value: 'trips', width: 45 },
];

export const contentTabs = [
  { text: G.getWindowLocale('titles:drivers', 'Drivers'), value: 'drivers' },
  { text: G.getWindowLocale('titles:tels', 'Trips'), value: 'trips' },
];

export const MODE = 'mode';
export const SEARCH_BY = 'searchBy';
export const EVENTS_MAX = 'eventsMax';
export const EVENTS_MIN = 'eventsMin';
export const SETTINGS_NAME = 'settingsName';
export const ORIGIN_DATE_TO = 'originDateTo';
export const ORIGIN_DATE_FROM = 'originDateFrom';
export const DESTINATION_DATE_TO = 'destinationDateTo';
export const DESTINATION_DATE_FROM = 'destinationDateFrom';
export const DRIVER_ENTERPRISE_GUID = 'DRIVER_ENTERPRISE_GUID';

export const LAST_KNOWN_LOCATION = 'lastKnownLocation';

export const DRIVER_LAST_KNOWN_LOCATION = 'LAST_KNOWN_LOCATION';
export const DRIVER_LAST_KNOWN_LOCATION_DATE = 'LAST_KNOWN_LOCATION_DATE';
export const DRIVER_LAST_KNOWN_LOCATION_CITY = 'LAST_KNOWN_LOCATION_CITY';
export const DRIVER_LAST_KNOWN_LOCATION_STATE = 'LAST_KNOWN_LOCATION_STATE';
export const DRIVER_FUTURE_AVAILABILITY_LOCATION_DATE = 'FUTURE_AVAILABILITY_LOCATION_DATE';
export const DRIVER_FUTURE_AVAILABILITY_LOCATION_CITY = 'FUTURE_AVAILABILITY_LOCATION_CITY';
export const DRIVER_FUTURE_AVAILABILITY_LOCATION_STATE = 'FUTURE_AVAILABILITY_LOCATION_STATE';
